import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34c83a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "namespace-main-settings-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "namespace-main-settings-page__title" }, "Основная информация", -1))
const _hoisted_3 = { class: "namespace-main-settings-page__content" }
const _hoisted_4 = { class: "namespace-main-settings-page__row" }
const _hoisted_5 = { class: "namespace-main-settings-page__button" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import {
  TirPmInput,
  TirPmIconPicker,
  IconType,
  IconColorType,
  SelectedIconModel,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from 'tir-components';
import { NamespaceFormDataModel, UpdateNamespaceModel } from './models';
import { AdapterService } from './adapter';
import { NamespaceModel } from '@/components/sidebar/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-main-settings-page',
  props: {
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
},
  emits: ["updateNamespacePage"],
  setup(__props, { emit }) {

const props = __props;





const adapter = new AdapterService();

const lastFormDataStr = ref('');
/**Данные формы */
const formData = ref(new NamespaceFormDataModel());

const isChangedForm = computed(() => lastFormDataStr.value !== JSON.stringify(formData.value));

/**Выбранная иконка */
const selectedIcon = computed({
  get() {
    if (formData.value.IconId)
      return new SelectedIconModel({
        IconId: formData.value.IconId,
        ColorId: formData.value.ColorId,
      });
  },
  set(value) {
    formData.value = new NamespaceFormDataModel({
      ...formData.value,
      IconId: value.IconId,
      ColorId: value.ColorId,
    });
  },
});

/**Список иконок */
const icons = ref(new Array<IconType>());
/**Список цветов */
const colors = ref(new Array<IconColorType>());
/**Состояние загрузки */
const isLoading = ref(false);
/**Состояние загрузки при сохранении */
const isLoadingSave = ref(false);

/**Получить иконки */
const getIcons = async () => {
  const resp = await adapter.getIcons();
  if (resp.IsSuccess) icons.value = resp.Value;
};

/**Получить цвета иконок */
const getColors = async () => {
  const resp = await adapter.getColors();
  if (resp.IsSuccess) colors.value = resp.Value;
};

/**Получить неймспейс */
const getNamespace = async () => {
  const resp = await adapter.getNamespace(props.namespaceId);
  if (resp.IsSuccess)
    formData.value = new NamespaceFormDataModel({
      Name: resp.Value.Name,
      IconId: resp.Value.IconId,
      ColorId: resp.Value.ColorId,
    });
  lastFormDataStr.value = JSON.stringify(formData.value);
};

/**Сохранить данные неймспейса */
const saveNamespace = async () => {
  isLoadingSave.value = true;

  const resp = await adapter.updateNamespace(
    new UpdateNamespaceModel({
      Id: props.namespaceId,
      Name: formData.value.Name,
      IconId: formData.value.IconId,
      ColorId: formData.value.ColorId,
    }),
  );
  if (resp.IsSuccess) {
    await getNamespace();
  }
  isLoadingSave.value = false;

  const icon = icons.value.find((x) => x.IconId == selectedIcon.value.IconId)?.IconUrl;
  const color = colors.value.find((c) => c.ColorId == selectedIcon.value.ColorId)?.Color;

  const namespace = new NamespaceModel({
    Id: props.namespaceId,
    Name: formData.value.Name,
    IconId: formData.value.IconId,
    ColorId: formData.value.ColorId,
    IconUrl: icon,
    Color: color,
  });
  emit('updateNamespacePage', namespace);
};

/**Инициализация данных */
const initData = async () => {
  isLoading.value = true;
  await Promise.all([getIcons(), getColors(), getNamespace()]);
  isLoading.value = false;
};

onMounted(() => {
  initData();
  document.addEventListener('update-namespace-from-sidebar', getNamespace);
});

onUnmounted(() => {
  document.removeEventListener('update-namespace-from-sidebar', getNamespace);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(TirPmInput), {
                modelValue: formData.value.Name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.Name) = $event)),
                class: "namespace-main-settings-page__namespace-name",
                label: "Название раздела",
                "is-with-hint": false
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TirPmIconPicker), {
                modelValue: selectedIcon.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIcon).value = $event)),
                icons: icons.value,
                colors: colors.value
              }, null, 8, ["modelValue", "icons", "colors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(TirPmButton), {
              variant: _unref(TirPmButtonVariantEnum).PrimaryState,
              size: _unref(TirPmButtonSizeEnum).Small,
              "is-loading": isLoadingSave.value,
              style: {"width":"6.625rem"},
              "is-disabled": !isChangedForm.value,
              onClick: saveNamespace
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["variant", "size", "is-loading", "is-disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})